import { defineComponent, onUnmounted, ref } from "vue";
import * as dayjs from "dayjs";
export default defineComponent({
  name: "CouponDialog",
  components: {},
  setup(props, {
    emit
  }) {
    let couponTimer = null;
    let couponTime = ref();
    function daojishi() {
      const endTime = dayjs().startOf("hour").add(1, "hour").unix();
      let diffTime = dayjs.duration(endTime * 1000 - dayjs());
      let hours = diffTime.hours(); //小时
      let minutes = diffTime.minutes(); //分
      let seconds = diffTime.seconds(); //秒
      let mseconds = diffTime.milliseconds(); //秒

      return `${minutes.toString().padStart(2, "0")}分${seconds.toString().padStart(2, "0")}秒${mseconds.toString().padStart(3, "0")}`;
    }
    function couponTimerStart() {
      couponTimer = setInterval(() => {
        couponTime.value = daojishi(dayjs().add(1, "day"));
      }, 100);
    }
    couponTimerStart();
    onUnmounted(() => {
      couponTimer = null;
    });
    return {
      couponTime,
      getCoupon() {
        emit("useCoupon", true);
      },
      close() {
        emit("close");
      }
    };
  }
});